<script setup lang="ts">
import { useTemplateRef } from 'vue';

interface Props {
  qrCodeUrl: string | null;
  showQrCode: boolean;
}

interface PhotoFromPhoneQrPanelPublicApi {
  readonly qrCodeContainer: HTMLElement | null;
  getQrCodeContainer: () => HTMLElement | null;
}

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const props = defineProps<Props>();
const qrCodeContainer = useTemplateRef<HTMLElement>('qrCodeContainer');

function getQrCodeContainer(): HTMLElement | null {
  return qrCodeContainer.value;
}

const publicApi: PhotoFromPhoneQrPanelPublicApi = {
  get qrCodeContainer(): HTMLElement | null {
    return qrCodeContainer.value;
  },
  getQrCodeContainer,
};

defineExpose(publicApi);
</script>

<template>
  <div
    v-if="showQrCode"
    ref="qrCodeContainer"
    class="PhotoFromPhone__qr"
    data-testid="photo-phone-qr"
  >
    <img
      v-if="qrCodeUrl"
      class="PhotoFromPhone__qr-image"
      :src="qrCodeUrl"
      data-testid="photo-phone-qr-image"
    />
  </div>

  <div
    v-else
    class="PhotoFromPhone__qr-placeholder"
    data-testid="photo-phone-qr-placeholder"
  >
    <p class="PhotoFromPhone__qr-placeholder-text">
      {{
        $t('PhotoFromPhone.gdprCheckboxesRequired') ||
        'Please check all boxes below to continue'
      }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.PhotoFromPhone__qr {
  width: var(--photo-from-phone-qr-width, 27rem);
  margin-right: var(--photo-from-phone-qr-margin-right, 4rem);
  margin-bottom: var(--photo-from-phone-qr-margin-bottom, 0);
}

.PhotoFromPhone__qr-image {
  display: block;
  width: 100%;
}

.PhotoFromPhone__qr-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--photo-from-phone-qr-width, 27rem);
  min-height: var(--photo-from-phone-qr-placeholder-min-height, 27rem);
  padding: var(--photo-from-phone-qr-placeholder-padding, 2rem);
  margin-right: var(--photo-from-phone-qr-margin-right, 4rem);
  margin-bottom: var(--photo-from-phone-qr-margin-bottom, 0);
  background: rgba(var(--Kiosk--font_color_rgb, 0, 0, 0), 0.05);
  border: 2px dashed rgba(var(--Kiosk--font_color_rgb, 0, 0, 0), 0.3);
  border-radius: 1rem;
}

.PhotoFromPhone__qr-placeholder-text {
  margin: 0;
  font-size: var(--photo-from-phone-qr-placeholder-font-size, 1.3rem);
  line-height: 1.6;
  color: var(--Kiosk--font_color);
  text-align: center;
  opacity: 0.7;
}
</style>
